import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthService} from "../services/auth.service";

export const bearerInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  const authReq = request.clone({
    headers: request.headers.set('Authorization', authService.getAuthHeader())
  });
  return next(authReq);
};
